import AuthWrapper from '../../components/AuthWrapper';
import ViewItems from '../../components/ViewItems';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import CustomInput from '../../components/CustomInput';
import Button from '../../components/Button';
import forgetPasswordFunctional from './index.function';
import { Formik } from 'formik';
import { forgot_password_validation_schema } from '../../validations_schemas/forgot_password_validation_schemas';
import ErrorText from '../../components/ErrorText';
import images from '../../constants/images';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';

const ForgetPassword = () => {
  const { TextWeight, isArabic, userName, authLoading, handleForgetPassword, navigate, getContentKey } = forgetPasswordFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />

        <img src={images.textLogo} width={70} className={cn('mt-10', isArabic ? 'self-end' : 'self-start')} />
        <Formik
          validationSchema={forgot_password_validation_schema}
          initialValues={{
            username: userName || '',
          }}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values) => handleForgetPassword(values)}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, values, errors }) => {
            const isValid = values?.username;
            return (
              <ViewItems className={'w-full'}>
                <Text text={getContentKey('forget_password')} weight={TextWeight.semiBold} size={fontSizes.h18} className={'mb-3 mt-10'} />
                <CustomInput
                  value={values?.username}
                  label={getContentKey('username')}
                  placeholder={getContentKey('username')}
                  divClasses={'mt-2'}
                  isRequired
                  onChange={(e) => setFieldValue('username', e.target.value)}
                  onPressEnter={() => handleSubmit()}
                />
                <ErrorText text={errors?.username} getContentKey={getContentKey} />

                <Button
                  text={getContentKey('submit')}
                  className={'mt-10 my-2 w-full'}
                  onClick={handleSubmit}
                  loading={authLoading}
                  isDisabled={!isValid}
                />
              </ViewItems>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default ForgetPassword;
